import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { deleteTournament } from "../../../api/deleteTournament";
import { deleteGoal } from "../../../api/deleteGoal";
import DeleteGoalTournamentModal from "../../Modals/DeleteGoalTournamentModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchGoalsData } from "../../../action/userOwnGoals";
import { fetchTounamentData } from "../../../action/userOwnTournament";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";

const options = ["Edit", "Delete", "Cancel"];
const OptionMenue = ({ data, filterState, deleteFunc, isAdmin }) => {
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEdit = () => {
    if (filterState == "goals") {
      if (data.goalCategory?.name == "Youth Football") {
        navigate(`/editGoal/${data.id}?from=Youth_Football`);
      } else {
        navigate(`/editGoal/${data.id}`);
      }
    } else if (filterState == 1) {
      navigate(`/editChallenge/${data.id}`);
    } else if (filterState == 2) {
      navigate(`/editTournament/${data.id}`);
    } else if (filterState == 3) {
      navigate(`/editClub/${data.id}`);
    } else if (filterState == 4) {
      navigate(`/editLeague/${data.id}`);
    }
  };


  const deleteHandler = async (data) => {
    setDeleting(true);

    await deleteFunc(data);
    setDeleting(false);
  };

  const handleDelete = () => {
    setOpenModal(true);
    // deleteTournament()
    setAnchorEl(null);
  };
  return (
    <>
      {deleting ? (
        <Typography component={"p"} sx={{ color: "#9697ae" }}>
          .....Deleting
        </Typography>
      ) : (
        <div>
          <Button
            id="fade-button"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            sx={{ color: "white" }}
          >
            <MoreVertIcon />
          </Button>
          <Menu
            id="fade-menu"
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            {isAdmin && <MenuItem onClick={handleDelete}>Delete</MenuItem>}
            <MenuItem onClick={handleClose}>Cancel</MenuItem>
          </Menu>
        </div>
      )}
      <DeleteGoalTournamentModal
        state={openModal}
        setState={setOpenModal}
        // handlerFunction={
        //   filterState == 2 ? deleteHandlerTournament : deleteHandlerGoals
        // }
        handlerFunction={deleteHandler}
        data={data}
        message={
          data?.tournamentGoalVideos
            ? "Are you sure. You want to delete this tournament"
            : "Are you sure you want to delete this Goal."
        }
      />
    </>
  );
};

export default OptionMenue;
